import { filterNonAstNodes } from '../parser';
import { buildArg } from './index';
import { buildName } from './operand';
import { buildType } from './type';
export const isPostfixOp = (op) => {
    return (op.kind === 'method-call-op' ||
        op.kind === 'field-access-op' ||
        op.kind === 'call-op' ||
        op.kind === 'unwrap-op' ||
        op.kind === 'bind-op' ||
        op.kind === 'await-op');
};
export const buildPostfixOp = (node) => {
    switch (node.kind) {
        case 'method-call-op':
            return buildMethodCallOp(node);
        case 'field-access-op':
            return buildFieldAccessOp(node);
        case 'call-op':
            return buildCallOp(node);
        case 'unwrap-op':
        case 'bind-op':
        case 'await-op':
            return { kind: node.kind, parseNode: node };
        default:
            throw Error(`expected postfix-op, got ${node.kind}`);
    }
};
export const associativityMap = new Map([
    ['add-op', 'left'],
    ['sub-op', 'left'],
    ['mult-op', 'left'],
    ['div-op', 'left'],
    ['exp-op', 'right'],
    ['mod-op', 'left'],
    ['eq-op', 'none'],
    ['ne-op', 'none'],
    ['ge-op', 'none'],
    ['le-op', 'none'],
    ['gt-op', 'none'],
    ['lt-op', 'none'],
    ['and-op', 'left'],
    ['or-op', 'left'],
    ['assign-op', 'none']
]);
/**
 * Similar to JavaScript priority table
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Operator_precedence#table
 */
export const precedenceMap = new Map([
    ['add-op', 11],
    ['sub-op', 11],
    ['mult-op', 12],
    ['div-op', 12],
    ['exp-op', 13],
    ['mod-op', 12],
    ['eq-op', 8],
    ['ne-op', 8],
    ['ge-op', 9],
    ['le-op', 9],
    ['gt-op', 9],
    ['lt-op', 9],
    ['and-op', 4],
    ['or-op', 3],
    ['assign-op', 2]
]);
export const buildBinaryOp = (node) => {
    if (![
        'add-op',
        'sub-op',
        'mult-op',
        'div-op',
        'exp-op',
        'mod-op',
        'eq-op',
        'ne-op',
        'ge-op',
        'le-op',
        'gt-op',
        'lt-op',
        'and-op',
        'or-op',
        'assign-op'
    ].includes(node.kind)) {
        throw Error(`expected binary-op, got ${node.kind}`);
    }
    return { kind: node.kind, parseNode: node };
};
export const buildMethodCallOp = (node) => {
    const nodes = filterNonAstNodes(node);
    let i = 0;
    const name = buildName(nodes[i++]);
    const typeArgs = nodes[i].kind === 'type-args' ? filterNonAstNodes(nodes[i++]).map(buildType) : [];
    const call = buildCallOp(nodes[i++]);
    return { kind: 'method-call-op', parseNode: node, name, typeArgs, call };
};
export const buildFieldAccessOp = (node) => {
    const name = buildName(filterNonAstNodes(node)[0]);
    return { kind: 'field-access-op', parseNode: node, name };
};
export const buildCallOp = (node) => {
    const args = filterNonAstNodes(node).map(n => buildArg(n));
    return { kind: 'call-op', parseNode: node, args };
};
//# sourceMappingURL=op.js.map